import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import { useDeleteUnknownTransactions } from "src/services/admin/commands/unkownTransactions";
import SnackbarUtils from "src/utils/SnackbarUtils";

import DialogContext from "../../../context";

export default function useDeleteTransaction() {
	const [isLoading, setIsLoading] = useState(false);
	const { actions, state } = useContext(DialogContext);

	const { mutate } = useDeleteUnknownTransactions();

	const queryClient = useQueryClient();

	const onDeleteTransaction = () => {
		setIsLoading(true);
		mutate(state.deleteIds, {
			onSuccess: () => {
				setIsLoading(false);
				queryClient.refetchQueries({ queryKey: ["adminUnknownTransactions"] });
				SnackbarUtils.success("Se ha eliminado con éxito tus transacciones.");
				actions.hideDeleteDialog();
			},
			onError: () => {
				setIsLoading(false);
				SnackbarUtils.error("Se ha producido un error al intentar eliminar tus transacciones.");
			}
		});
	};

	return { onDeleteTransaction, isLoading };
}
